var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2117_7552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9262 19.1074C68.7909 19.1074 68.6759 19.0796 68.5812 19.0239C68.4865 18.9682 68.4121 18.8707 68.3579 18.7315L67.1808 15.8914L64.2177 14.5549C64.0824 14.4992 63.9877 14.4226 63.9336 14.3252C63.8795 14.2277 63.8524 14.1094 63.8524 13.9702C63.8524 13.8309 63.8795 13.7126 63.9336 13.6152C63.9877 13.5177 64.0824 13.4411 64.2177 13.3854L67.1808 12.0907L68.3579 9.37589C68.4121 9.23667 68.4865 9.13922 68.5812 9.08353C68.6759 9.02784 68.7909 9 68.9262 9C69.0615 9 69.1765 9.02784 69.2712 9.08353C69.3659 9.13922 69.4403 9.23667 69.4945 9.37589L70.6716 12.0907L73.6347 13.3854C73.77 13.4411 73.8647 13.5177 73.9188 13.6152C73.9729 13.7126 74 13.8309 74 13.9702C74 14.1094 73.9729 14.2277 73.9188 14.3252C73.8647 14.4226 73.77 14.4992 73.6347 14.5549L70.6716 15.8914L69.4945 18.7315C69.4403 18.8707 69.3659 18.9682 69.2712 19.0239C69.1765 19.0796 69.0615 19.1074 68.9262 19.1074ZM68.9262 44C68.818 44 68.7097 43.9722 68.6015 43.9165C68.4932 43.8608 68.4121 43.7633 68.3579 43.6241L67.1808 40.9093L64.2583 39.6146C64.123 39.5589 64.0283 39.4823 63.9742 39.3848C63.92 39.2874 63.893 39.1691 63.893 39.0298C63.893 38.8906 63.92 38.7723 63.9742 38.6748C64.0283 38.5774 64.123 38.5008 64.2583 38.4451L67.1808 37.1504L68.3579 34.2685C68.4121 34.1293 68.4865 34.0318 68.5812 33.9761C68.6759 33.9204 68.7909 33.8926 68.9262 33.8926C69.0615 33.8926 69.1765 33.9204 69.2712 33.9761C69.3659 34.0318 69.4403 34.1293 69.4945 34.2685L70.6716 37.1504L73.5941 38.4451C73.7294 38.5008 73.8241 38.5774 73.8782 38.6748C73.9324 38.7723 73.9594 38.8906 73.9594 39.0298C73.9594 39.1691 73.9324 39.2874 73.8782 39.3848C73.8241 39.4823 73.7294 39.5589 73.5941 39.6146L70.6716 40.9093L69.4945 43.6241C69.4403 43.7633 69.3592 43.8608 69.2509 43.9165C69.1427 43.9722 69.0344 44 68.9262 44ZM51.107 36.7745C50.8905 36.7745 50.6808 36.7118 50.4779 36.5865C50.2749 36.4612 50.1193 36.2872 50.0111 36.0644L47.3727 30.259L41.69 27.6277C41.4736 27.5163 41.3044 27.3562 41.1827 27.1474C41.0609 26.9385 41 26.7228 41 26.5C41 26.2772 41.0609 26.0615 41.1827 25.8526C41.3044 25.6438 41.4736 25.4837 41.69 25.3723L47.3727 22.7411L50.0111 16.9773C50.1193 16.7267 50.2749 16.5388 50.4779 16.4135C50.6808 16.2882 50.8905 16.2255 51.107 16.2255C51.3235 16.2255 51.5332 16.2882 51.7362 16.4135C51.9391 16.5388 52.0947 16.7128 52.203 16.9356L54.8819 22.7411L60.524 25.3723C60.7675 25.4837 60.9502 25.6438 61.072 25.8526C61.1937 26.0615 61.2546 26.2772 61.2546 26.5C61.2546 26.7228 61.1937 26.9385 61.072 27.1474C60.9502 27.3562 60.7675 27.5163 60.524 27.6277L54.8819 30.259L52.203 36.0644C52.0947 36.315 51.9391 36.496 51.7362 36.6074C51.5332 36.7188 51.3235 36.7745 51.107 36.7745Z",
    fill: "#603CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2117_7552",
    x: 0.0499992,
    y: 0.549999,
    width: 114.9,
    height: 116.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.475
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.0941176 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2117_7552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2117_7552",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.22d7d924498a61ff96379241ec1589c2.svg";
export { ForwardRef as ReactComponent };